export default function Numpy_Certificate() {
  return <div>Numpy_Certificate Component</div>;
}
